import {atom} from "recoil";
import {IVaultWallet} from "./types";

export const vaultsAtom = atom<IVaultWallet[]>({
    key: 'vaultAtom',
    default: [] as IVaultWallet[]
})
